import slice from "./menus.slice";

const { setOpenMenu } = slice.actions;

export { setOpenMenu };
